<template>
  <router-view :key="$route.fullPath"></router-view>
</template>

<script>
import axios from "axios";
import {apiUrls} from "./api/apiUrls"
//import ErroreGenerico from "./components/modalErrors/erroreGenerico/ErroreGenerico.vue"
export default {
  name: 'App',
  components: {
    //'erroreGenerico': ErroreGenerico
  },
  created() {
        this.$store.dispatch("CHECK_USER_ALREADY_LOGGED")
      
        if(!this.$store.state.userIsLoggedIn){
          let email = process.env.VUE_APP_EMAIL
          let password = process.env.VUE_APP_PASSWORD
          let tokenId = process.env.VUE_APP_TOKEN_ID
          if(email && password){
                axios
                  .post("login/", {
                      email: email,
                      password: password,
                  })
                  .then((response) => {
                      
                      if(response.data && response.data.token){
                          localStorage.setItem(tokenId, response.data.token);
                          
                          this.$store.commit('login')
                          response.data && response.data.user && localStorage.setItem("last_user_id", response.data.user.id);
                          response.data && response.data.user && this.$store.commit('setUserData',response.data.user)
                      }
                  })
                  .catch((error) => {
                      
                      this.$store.commit('logout')
                  });
                }
        }else{
           axios
              .get(apiUrls["user_detail"] + localStorage.getItem("last_user_id"))
                    .then((response) => {
                        if(response.data){
                          this.$store.commit('setUserData',response.data)
                        }
                    })
                    .catch((error) => {
                        
                        this.$store.commit('logout')
                    });
          }
     
        
        
        
    }, 
}
</script>

